import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";
import {
  ENCOUNTERS,
  LEAD_CARE_MANAGER,
  SUBMIT_ANSWER,
  SURVEY,
  SURVEY_COMMENTS,
  TASKS,
  USERS,
  EXPENSE_AUTHORIZATIONS,
} from "constants/endpoints";
import { result } from "lodash";
import { toast } from "react-toastify";
import { deleteApi, get, post, put } from "services/network";
export const getActiveUsers = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    id: obj.id ? obj.id : "",
    status: obj.status ? obj.status : "",
    search: obj.search ? obj.search : "",
  };
  try {
    let url = `${USERS}?page=${params.page}&per=${params.perPage}&filter[status]=active`;
    if (params.search) {
      url += `&query=${encodeURIComponent(params.search)}`;
    }
    const result = await get(url, true);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "An error occurred"}
      />,
    );
    console.error(error); // Log the actual error
  }
};

export const addTask = async (task) => {
  try {
    const result = await post(
      `${TASKS}`,
      {
        task: {
          ...task,
        },
      },
      true,
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Task created successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const updateTask = async (id, task) => {
  try {
    const result = await put(
      `${TASKS}/${id}`,
      {
        task: {
          ...task,
        },
      },
      true,
    );
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Task created successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};

export const showSurvey = async (id, templateId = "") => {
  try {
    const result = await post(
      `${SURVEY}`,
      {
        survey_response: {
          member_id: id,
          template_id: templateId,
        },
      },
      true,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const getSurveyHistory = async (obj) => {
  const params = {
    status: obj.status ? obj.status : "",
    id: obj.id ? obj.id : "",
    page: obj.page ? obj.page : 1,
    per: obj.perPage ? obj.perPage : 10,
  };
  try {
    const result = await get(
      `${SURVEY}?filter[member_id]=${params.id}&filter[status]=${params.status}&page=${params.page}&per=${params.per}`,
      true,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const getSurveyAnswers = async (id) => {
  try {
    const result = await get(`${SURVEY}/${id}/review_answers`, true);
    return result;
  } catch (error) {
    console.log(result);
  }
};
export const submitQuestion = async (id, optionId) => {
  const payload = {
    answer: {
      selected_answer_options_attributes: optionId,
    },
  };
  try {
    const result = await put(`${SUBMIT_ANSWER}/${id}`, payload, true);
    toast(<CustomToast variant={alertTypes.INFO} message="Answer Saved" />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const submitAllQuestions = async (id) => {
  const payload = {
    survey_response: {
      status: "completed",
    },
  };
  try {
    const result = await put(`${SURVEY}/${id}`, payload, true);
    toast(<CustomToast variant={alertTypes.INFO} message="Answer Submitted" />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const submitLeadCareManager = async (id, optionId) => {
  const payload = {
    survey_response: {
      lead_care_manager_id: optionId,
    },
  };
  try {
    const result = await put(`${SURVEY}/${id}`, payload, true);
    toast(<CustomToast variant={alertTypes.INFO} message="Answer Saved" />);
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText}
      />,
    );
    console.log(result);
  }
};
export const discardSurvey = async (id) => {
  try {
    const result = await deleteApi(`${SURVEY}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={result?.message || "HousingExpense deleted successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "delete"}
      />,
    );
    console.log(result);
  }
};

export const getLeadCareManagersByLocation = async (memberId) => {
  // const params = {
  //   page: obj?.page ? obj.page : 1,
  //   perPage: obj?.perPage ? obj.perPage : 10,
  //   search: obj?.search ? obj.search : '',
  //   filter: obj?.status ? obj.status : '',
  // };
  try {
    const result = await get(
      `${LEAD_CARE_MANAGER}/filter_by_member_locations?member_id=${memberId}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const getSurveyComments = async (memberId) => {
  try {
    const result = await get(
      `${SURVEY_COMMENTS}?filter[commentable_type]=Member&filter[commentable_id]=${memberId}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createSurveyComment = async (memberId, content) => {
  try {
    const result = await post(
      `${SURVEY_COMMENTS}`,
      {
        comment: {
          content,
          commentable_type: "Member",
          commentable_id: memberId,
        },
      },
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const updateSurveyComment = async (commentId, content) => {
  try {
    const result = await put(
      `${SURVEY_COMMENTS}/${commentId}`,
      {
        comment: {
          content,
        },
      },
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createExpenseAuthorization = async (
  data,
  setErrors = () => {},
) => {
  try {
    const result = await post(`${EXPENSE_AUTHORIZATIONS}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Expense authorization created successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors({ newAuthorization: error?.response?.data.errors });
    }
    // toast(
    //   <CustomToast
    //     variant={alertTypes.DANGER}
    //     message={error?.response?.data?.errors?.auth_type}
    //   />
    // );
    setErrors({ apiError: error?.response?.data?.errors?.auth_type });
    console.log(error);
  }
};

export const updateExpenseAuthorization = async (
  id,
  data,
  setErrors = () => {},
) => {
  try {
    const result = await put(`${EXPENSE_AUTHORIZATIONS}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Expense authorization updated successfully"
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors({
        newAuthorization: error?.response?.data.errors,
      });
    }
    // toast(
    //   <CustomToast
    //     variant={alertTypes.DANGER}
    //     message={
    //       error?.response?.statusText ||
    //       "Failed to update expense authorization"
    //     }
    //   />
    // );
    setErrors({
      apiError: error?.response?.data?.errors?.auth_type,
    });
    console.log(error);
  }
};

export const discardEncounter = async (id) => {
  try {
    const result = await deleteApi(`${ENCOUNTERS}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message="Encounter deleted successfully"
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "delete"}
      />,
    );
    console.log(result);
  }
};
